import script from './SpinnerCircle.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"spinner-circle",attrs:{"viewBox":"0 0 50 50","width":_vm.size,"height":_vm.size}},[_c('linearGradient',{attrs:{"id":"spinner-circle-gradient"}},[_c('stop',{attrs:{"offset":"0%","stop-color":_vm.color}}),_vm._v(" "),_c('stop',{attrs:{"offset":"100%","stop-color":_vm.color,"stop-opacity":"0.01"}})],1),_vm._v(" "),_c('circle',{staticClass:"spinner-circle__path",attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke":"url(#spinner-circle-gradient)","stroke-width":"6"}})],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-a047c0cc_0", { source: ".spinner-circle[data-v-a047c0cc]{opacity:.5;animation:rotate-spinner-circle-data-v-a047c0cc 1s linear infinite}.spinner-circle__path[data-v-a047c0cc]{stroke-linecap:round;stroke-dasharray:90,150}@keyframes rotate-spinner-circle-data-v-a047c0cc{100%{transform:rotate(360deg)}}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-a047c0cc";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
